module.exports = __webpack_public_path__ + "static/media/powered-by.b732b2c3.png";